import teamAssignment from 'views/application/entryBlocks/blocks/teamAssignment';

export default {
	...teamAssignment,
};
